import { Input } from 'avo-ui'
import ModalForm from 'components/commons/modal-form'
import UploadImage from 'components/commons/upload-image'

export const FormBrandNomination = ({
    show,
    onHideForm,
    dataBrandNomination,
    isLoading,
    isDisabled,
    onChangeForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-fit'}
            show={show}
            onHide={onHideForm}
            title={`${!dataBrandNomination?.id ? 'Create' : 'Update'} Brand Nomination`}
            isLoading={isLoading}
            isDisabled={isDisabled}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <div
                    className={`flex-1 flex-col ${(dataBrandNomination?.image_url?.base64 || dataBrandNomination?.image_url) && 'space-y-3'}`}
                >
                    <div className={'font-semibold text-blue-90 required'}>Gambar Brand</div>
                    <UploadImage
                        className={'w-fit'}
                        classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                        id={'image-brand'}
                        value={dataBrandNomination?.image_url?.base64 || dataBrandNomination?.image_url}
                        onChange={(value) => onChangeForm({ name: 'image_url', value })}
                    />
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Nama Brand</div>
                    <Input
                        className={'flex-1'}
                        name={'name'}
                        placeholder={'Masukkan nama brand'}
                        value={dataBrandNomination?.name}
                        onChange={onChangeForm}
                    />
                </div>
            </div>
        </ModalForm>
    )
}
